import React, { useCallback } from 'react';
import { isEmpty } from 'lodash';
import useEntityFormContext from '../containers/EntityForm/internal/useEntityFormContext';
import TextArea from './base/TextArea';
import TextAreaHighlight from './base/TextAreaHighlight';
const ENTER_KEY = 13;
const FormTextArea = ({ input: { name, value, onChange, onPaste, ...restInput }, meta: { touched, error, submitting, submitFailed }, disabled, hasSubmitOnEnter, onMouseUp, onBlur, handleSelect, errorMessage, hasSearch, dataCy, ...rest }) => {
    const { submitForm, resetForm, values } = useEntityFormContext();
    const onKeyDown = useCallback(async (event) => {
        if (hasSubmitOnEnter &&
            event.keyCode === ENTER_KEY &&
            !event.shiftKey &&
            !event.ctrlKey &&
            !event.altKey) {
            event.preventDefault();
            const content = value || '';
            const attachments = (values === null || values === void 0 ? void 0 : values.attachments) || [];
            if (!isEmpty(content.trim()) || !isEmpty(attachments)) {
                await submitForm();
                await resetForm();
            }
            return false;
        }
        return true;
    }, [hasSubmitOnEnter, submitForm, resetForm, value, values]);
    return (<>
      {hasSearch ? (<TextAreaHighlight dataCy={dataCy} disabled={disabled || submitting} errorMessage={((touched || submitFailed) && (errorMessage || error)) || undefined} handleSelect={handleSelect} inputProps={restInput} name={name} value={value} onBlur={onBlur} onChange={onChange} onKeyDown={onKeyDown} onMouseUp={onMouseUp} onPaste={onPaste} {...rest}/>) : (<TextArea dataCy={dataCy} disabled={disabled || submitting} errorMessage={((touched || submitFailed) && (errorMessage || error)) || undefined} handleSelect={handleSelect} inputProps={restInput} name={name} value={value} onBlur={onBlur} onChange={onChange} onKeyDown={onKeyDown} onMouseUp={onMouseUp} onPaste={onPaste} {...rest}/>)}
    </>);
};
export default FormTextArea;
